<template>
  <b-container
    fluid
    class="px-0">
    <b-row>
      <b-col>
        <b-alert 
          variant="warning"
          :show="onHold"
          :held-by="heldBy"
          class="p-2 mb-0">
          <b-row>
            <b-col class="pt-2">
              On hold by {{ heldBy }}
            </b-col>
            <b-col>
              <b-btn
                variant="warning"
                class="float-right"
                @click="clearHold">
                Clear Hold
              </b-btn>
            </b-col>
          </b-row>
        </b-alert>
      </b-col>
    </b-row>
    <b-row v-if="isScheduled">
      <b-col>
        <b-alert
          variant="warning"
          :show="isScheduled"
          class="p-2 mb-0">
          <b-row>
            <b-col
              cols="8"
              class="pt-2">
              Promotion is scheduled by {{ schedulingInfo.requestingUser }} for {{ formatDateTime(schedulingInfo.promoteTime) }}
            </b-col>
            <b-col>
              <b-btn
                variant="warning"
                class="float-right"
                @click="$emit('cancel-scheduled')">
                Cancel Scheduled
              </b-btn>
            </b-col>
          </b-row>
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        class="mr-auto">
        <b-row>
          <b-col
            v-if="toolName"
            cols="auto"
            class="tool-name mr-auto">
            {{ toolName }}
          </b-col>
        </b-row>
      </b-col>
      <b-col
        sm
        class="mt-2 mt-md-0 pt-2">
        <slot />
      </b-col>
    </b-row>
    <b-row>
      <b-col
        v-if="toolIconText"
        class="tool-icon-text">
        {{ toolIconText }}
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import moment from "moment-timezone"

  export default {
    name: "ToolHeader",
    props: {
      toolName: {
        type: String,
        default: "",
      },
      toolIconText: {
        type: String,
        default: "",
      },
      onHold: {
        type: Boolean,
        default: false,
      },
      heldBy: {
        type: String,
        default: "",
      },
      schedulingInfo: {
        type: Object,
        default: null,
      },
    },
    computed: {
      isScheduled() {
        return this.schedulingInfo && this.schedulingInfo.cloudTaskName !== ""
      },
    },
    methods: {
      clearHold() {
        this.$emit('clearHold')
      },
      formatDateTime(date) {
        return moment(date).tz(moment.tz.guess()).format('MM/DD/YYYY[ at ]hh:mm A')
      },
    },
  }
</script>

<style scoped>
  .tool-name {
    font-size: 32px;
    color: #333333;
  }
  .tool-icon-text {
    font-size: 20px;
    color: #333333;
  }
  .float-right {
    float: right;
  }
  .alert-banner {
    line-height: 24px;
    padding: 1px;
  }
</style>
